const styles = {
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  controlsButton: {
    marginRight: '5px',
  },
  hoverStyle:{
    '&:hover': {
      cursor: "pointer",
    },
  }
};

export default styles;
